import { IonButton, IonCheckbox, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import Mobiscroll from '../../components/mobiscroll';
import NoData from '../../components/noData';
import Loading from '../../components/spinner';
import api from '../../lib/api';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { cutoffTime, deepCopy, forwardTo, forwardToDeliveryOption, isArray, isDefined, isEmptyObject, isObject, isWebConfig, parseAllergenData, goBack, getDistanceUnit, getDistance } from '../../lib/utils';
import { checkSnoozedTimes, formatDataForTime, getMenusForSelectedTime, isStoreOpened } from '../../screens/clickAndCollect';
import { loading, setDeliveryOption, setDeliveryTime } from '../../store/actions';
import { setCommonModal, showToast } from '../../store/common/actions';
import { SET_RESTAURANT_PROP } from '../../store/constants';
import { getIkentooMenu, getIkentooMenusForLocation, passedTheOrder } from '../../store/restaurants/actions';
import { filterMenu } from '../../store/restaurants/sagas';
import 'moment-timezone';
import './index.css';
import 'moment-timezone';
import Modal from '../../components/modal';
const { shouldAddPrepTime } = Basket;
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';
import { PillGroup } from '../../components/pill';

const { SelectOption } = Mobiscroll;

class DeliveryTime extends React.Component {
	pickerRef = React.createRef();
	pickerRefCharter = React.createRef();
	state = {
		selectedTime: null,
		pickTime: null,
		formatted: null,
		selectedTimeOption: null,
		continueButtonClicked: false,
		showOnlyPickUpText: false,
		restaurantIsClosed: false,
		selectRestaurantModalOpen: Basket.has_multi_basket
	};

	checkDelivery = () => {
		if (!Basket.getDeliveryOption() || (!Basket.getDeliveryAddress() && !Basket.getPickUpPoint())) {
			forwardToDeliveryOption();
		}
	};

	getMenus = () => {
		// const charterDelivery = this.props.deliveryOption ? (this.props.deliveryOption.deliveryOption?.id === 'charter-delivery' ? true : false) : false;
		// if (!charterDelivery && !this.props.deliveryOption && !this.props.location.state?.collectionTimeRestaurant) {
		// 	this.props.dispatch(getIkentooMenusForLocation(Basket.getRestaurant() ? Basket.getRestaurant().business_location_id : null, {}, true));
		// }
	};

	async componentDidMount() {

		const { deliveryOption } = this.props;
		let dataForDeliveryOption = null;
		if (!Basket.has_multi_basket) {
			const addressLng = Basket.getDeliveryAddress()?.lng
			const addressLat = Basket.getDeliveryAddress()?.lat
			this.props.location.state.checkedCodeData.forEach(data => {
				const restaurant = [...this.props.restaurants].find(el => el.id == data.restaurant_id) || null
				if (restaurant && addressLat && addressLng) {
					data.distance = getDistance(restaurant.position, addressLat, addressLng)
				}
			})
			this.props.location.state.checkedCodeData.sort((a, b) => (a.distance == null ? (b.distance == null ? a.restaurant_name.localeCompare(b.restaurant_name) : 1) : (b.distance == null ? -1 : a.distance - b.distance))
			)
			const closestRestaurantData = this.props.location.state.checkedCodeData[0]
			const selectedRestaurant = [...this.props.restaurants].find(el => el.id == closestRestaurantData.restaurant_id) || null
			if (selectedRestaurant) {
				Basket.setRestaurant(selectedRestaurant)
				Basket.setDeliveryMinOrder(closestRestaurantData?.delivery_zone?.min_order || 0)
				Basket.setDeliveryPrice(closestRestaurantData?.delivery_zone?.price || 0)
			}
		}
		const choosenRestaurant = Basket.getRestaurant();
		const orderType = Basket.getDeliveryOption().id;
		let additionalSettings = choosenRestaurant && choosenRestaurant.additional_delivery_settings ? choosenRestaurant.additional_delivery_settings : {};
		additionalSettings = additionalSettings[orderType];
		if (!deliveryOption) {
			const order_type = Basket.getOrderType();
			this.props.dispatch(loading(true));
			let deliveryConfig = getConfig()?.delivery;
			if (!deliveryConfig || isEmptyObject(deliveryConfig)) {
				const config = await api.getFrontEndAppConfig()
				deliveryConfig = config?.front_end_app_config?.delivery;
			}
			this.props.dispatch(loading(false));
			Object.keys(deliveryConfig).map((key) => {
				if (deliveryConfig[key].id === order_type.toLowerCase()) {
					dataForDeliveryOption = deliveryConfig[key];
				}
				return true;
			});
			this.props.dispatch(setDeliveryOption(dataForDeliveryOption));
			if (!this.props.location.state?.saveOrderData) {
				this.getMenus();
			}
		} else {
			if (!this.props.location.state?.saveOrderData) {
				this.getMenus();

			}
		}
		const snoozedTimes = checkSnoozedTimes(choosenRestaurant, 'charter-delivery');


		const currentDT = moment().tz(getConfig().timezone);
		let minDT = currentDT;
		if (choosenRestaurant && isDefined(choosenRestaurant.charter_delivery_order_slot_lead_time) && shouldAddPrepTime()) {
			minDT.add(choosenRestaurant.charter_delivery_order_slot_lead_time, 'minutes');
		}

		if (additionalSettings && additionalSettings.asap === false && additionalSettings.timePicker === false && !isStoreOpened(choosenRestaurant)) {
			this.setState({ restaurantIsClosed: true });
		} else {
			const timePickerOptions = formatDataForTime(choosenRestaurant, minDT, choosenRestaurant?.id, true, false, snoozedTimes);
			if (timePickerOptions && timePickerOptions[0].text !== 'CLOSED' && additionalSettings && additionalSettings.asap && additionalSettings.timePicker === false) {
				const hasPickUpText = additionalSettings?.hasPickUpText;
				this.props.dispatch(loading(true));
				this.setState({ selectedTime: 'asap', showOnlyPickUpText: hasPickUpText }, () => {
					if (!hasPickUpText) {
						this.confirmTime();
					}
					this.props.dispatch(loading(false));
				});
			}
		}
		if (this.props.location?.state?.saveOrderData) {
			this.setState({ selectedTime: 'asap' }, () => {
				this.confirmTime()
			})
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.deliveryOption !== prevProps.deliveryOption) {
			this.getMenus();
		}
		if (this.props.ikentooMenusForLocation.length !== prevProps.ikentooMenusForLocation.length) {
			if (this.props.ikentooMenusForLocation[0]) {
				this.setState({
					selectedIkentooMenu: this.props.ikentooMenusForLocation[0].ikentooMenuId,
				});
			}
		}

	}
	confirmTime = async () => {
		const { selectedTime } = this.state;
		const { dispatch, deliveryOption } = this.props;
		const deliveryOptionBasket = Basket.getDeliveryOption();
		const orderType = Basket.order_type; // TODO Update in time
		this.setState({ continueButtonClicked: true }, async () => {
			const isCharterDelivery = deliveryOptionBasket ? (deliveryOptionBasket?.id || orderType === 'charter-delivery' ? true : false) : false;
			const choosenRestaurant = Basket.getRestaurant();
			const businessLocationId = choosenRestaurant.business_location_id;
			// Basket.setProcessingFee();
			const pickTime = moment().tz(getConfig().timezone).format('HH:mm');
			let additionalSettings = choosenRestaurant && choosenRestaurant.additional_delivery_settings ? choosenRestaurant.additional_delivery_settings : {};
			additionalSettings = additionalSettings[this.props.deliveryOption?.id];
			if (selectedTime && !isCharterDelivery && selectedTime !== 'asap') {
				this.props.dispatch(setDeliveryTime(selectedTime));
				Basket.setCollectionTime(selectedTime.formattedDT);
				let restaurant = Basket.getRestaurant();
				let slots = restaurant?.delivery_times_json?.slots;
				let cutoffTimeRes = cutoffTime(selectedTime.formattedDT, slots);
				Basket.setCutoffTime(cutoffTimeRes);
				dispatch(passedTheOrder(true));
				Basket.setPassedOrder(true);
			} else {
				let pickTime = selectedTime;
				this.props.dispatch(setDeliveryTime(selectedTime));
				Basket.setCollectionTime(this.state.formatted);
				Basket.setCutoffTime(moment().add(15, 'minutes').tz(getConfig().timezone).unix());
				Basket.setASAP(false);
				if (additionalSettings?.asap && this.state.selectedTime == 'asap') {
					Basket.setASAP(true);
					const currentDT = moment().tz(getConfig().timezone);
					if (choosenRestaurant && isDefined(choosenRestaurant.charter_delivery_order_slot_lead_time) && shouldAddPrepTime()) {
						currentDT.add(choosenRestaurant.charter_delivery_order_slot_lead_time, 'minutes');
					}
					Basket.setCollectionTime(currentDT)
				}
				if (isCharterDelivery && getConfig().flags.delivery_asap) {
					Basket.setASAP(true);
				}

				if (this.props.location.state && this.props.location.state.selectedRestaurant) {
					this.props.dispatch(loading(true))

					let ikentooMenusForLocation = await api.getIkentooMenusForLocation(businessLocationId);
					let time_selector = isCharterDelivery ? choosenRestaurant.charter_delivery_times_json : choosenRestaurant.delivery_times_json;
					ikentooMenusForLocation = getMenusForSelectedTime(ikentooMenusForLocation, pickTime, time_selector);
					if (ikentooMenusForLocation && isObject(ikentooMenusForLocation[0])) {
						let ikentooMenus = [];
						try {
							for (let i = 0; i < ikentooMenusForLocation.length; i++) {
								ikentooMenus.push(await api.getIkenooMenu(ikentooMenusForLocation[i].ikentooMenuId, businessLocationId, 'delivery'));
							}
						} catch (error) {
							this.setState({ error: 'Get restaurant menu error.' });
							this.setState({ continueButtonClicked: false });
							this.props.dispatch(loading(false))

						}
						const reorderItems = this.props.location.state.selectedRestaurant.items;
						const menu = this.getMenuForReorder(ikentooMenus, reorderItems);
						if (menu) {
							dispatch({
								type: SET_RESTAURANT_PROP,
								key: 'ikentooMenu',
								value: menu,
							});
							if (menu.flattenMenuItems.length > 0) {
								let validationStatus = {
									notBasketEmpty: false,
									validationError: false,
								};
								reorderItems.map((newBasketItem) => {
									let foundItem = menu.flattenMenuItems.find((i) => i.sku === newBasketItem.item.sku);
									if (foundItem && Basket.isProductEnabled(foundItem)) {
										if (newBasketItem?.selectedChoices?.length > 0) {
											newBasketItem.selectedChoices = Basket.filterReorderChoices(newBasketItem.selectedChoices, foundItem);
										}
										newBasketItem.item = foundItem;
										Basket.addToBasket(newBasketItem);
										let item = newBasketItem.item;
										let allergens = this.props.allergens;
										let profile = this.props.profile;
										let newArr = parseAllergenData(profile, item, allergens);
										let allergensCodes = newBasketItem.item?.itemRichData?.allergenCodes.length > 0 ? newBasketItem.item.itemRichData.allergenCodes : [];
										if (allergensCodes.length > 0) {
											let allergensData = [{ allergens: newArr }, { sku: newBasketItem.item.sku }];
											Basket.setAllergen(allergensData);
										}
										validationStatus.notBasketEmpty = true;
									} else {
										validationStatus.validationError = true;
									}
								});
								if (validationStatus.notBasketEmpty) {
									if (validationStatus.validationError) {
										dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
										this.setState({ continueButtonClicked: false });
									}
									forwardTo('/order-summary', {
										skipBackToThePreviousPage: false,
										stopLoading: true
									});
								} else {
									dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
									this.setState({ continueButtonClicked: false });
									this.props.dispatch(loading(false))

								}
							} else {
								dispatch(showToast('Menu not found', 'warning'));
								this.setState({ continueButtonClicked: false });
								this.props.dispatch(loading(false))

							}
						} else {
							dispatch(showToast('Menu not found', 'warning'));
							this.setState({ continueButtonClicked: false });
							this.props.dispatch(loading(false))

						}
					}
					else {
						dispatch(showToast('Menu not found', 'warning'));
						this.setState({ continueButtonClicked: false });
						this.props.dispatch(loading(false))

					}
				} else {
					let time_selector = isCharterDelivery ? choosenRestaurant.charter_delivery_times_json : choosenRestaurant.delivery_times_json;
					dispatch(
						getIkentooMenusForLocation(businessLocationId, {
							pickTime:selectedTime,
							json_time_selector: choosenRestaurant ? time_selector : [],
						}),
					);
					this.setState({ continueButtonClicked: false });
				}
			}
		});
	};

	changeIkentooMenus = (event) => this.setState({ selectedIkentooMenu: event.detail.value, error: '' });

	formatDayName = (name, key) => {
		if (name.includes('Today')) {
			name = 'Today';
		} else if (name.includes('Tomorrow')) {
			name = 'Tomorrow';
		} else {
			name = key;
		}
		return name;
	};

	formatTimes = (deliveryTimesJson) => {
		const { deliveryOption } = this.props;
		const formatSelectOptionDays = [];
		const daysAhead = deliveryTimesJson ? deliveryTimesJson.days_ahead : null;
		const timezone = getConfig().timezone;
		let list = [];
		let picker = [];
		let cnt = 0;
		if (deliveryTimesJson) {
			Array(daysAhead)
				.fill('')
				.forEach((day, i) => {
					let formatDay = moment().tz(timezone).add(i, 'days');
					let formatDayName = formatDay.format('dddd');
					formatSelectOptionDays.push({ formatDayName, formattedDT: formatDay });
				});
			formatSelectOptionDays.forEach((option) => {
				let daySlot = deliveryTimesJson.slots[option.formatDayName];
				daySlot.forEach((slot) => {
					let h = parseInt(slot.start_time.split(':')[0]);
					let m = parseInt(slot.start_time.split(':')[1]);
					let prepTime = null;
					prepTime = moment().tz(timezone).add(slot.prep_time, 'hours');
					const formattedDT = option.formattedDT.hours(h).minutes(m);
					let label = this.formatDayName(option.formattedDT.calendar(), option.formatDayName);
					option.label = label;
					if (prepTime.isBefore(formattedDT)) {
						cnt++;
						let text = '';
						if (label === 'Today' || label === 'Tomorrow') {
							text =
								label +
								', ' +
								(deliveryOption && (deliveryOption.id === 'delivery' || deliveryOption.id === 'charter-delivery')
									? moment(slot.start_time, 'HH:mm').format('h:mm a') + ' - ' + moment(slot.end_time, 'HH:mm').format('h:mm a')
									: moment(slot.start_time, 'HH:mm').format('h:mm a'));
						} else {
							text =
								label +
								' ' +
								option.formattedDT.format('Do MMMM') +
								', ' +
								(deliveryOption && (deliveryOption.id === 'delivery' || deliveryOption.id === 'charter-delivery')
									? moment(slot.start_time, 'HH:mm').format('h:mm a') + ' - ' + moment(slot.end_time, 'HH:mm').format('h:mm a')
									: moment(slot.start_time, 'HH:mm').format('h:mm a'));
						}
						if (cnt <= 4) {
							list.push({
								formattedDT: formattedDT.format(),
								text,
								value: text,
								menuIds: slot.menu_ids || null,
							});
						} else {
							picker.push({
								formattedDT: formattedDT.format(),
								text,
								value: text,
								menuIds: slot.menu_ids || null,
							});
						}
					}
				});
			});
			return { list, picker };
		}
		return { list: [], picker: [] };
	};
	getMenuForReorder = (menus, reorderItems) => {
		let menuForReorder = [];
		for (let i = 0; i < menus.length; i++) {
			let foundItems = 0;
			const categoryItems = menus[i].menuEntry || menus[i].menuEntryGroups || null;
			let items = Basket.flattenMenuItems(deepCopy(categoryItems));
			menus[i].flattenMenuItems = items;
			if (items.length > 0) {
				for (let j = 0; j < reorderItems.length; j++) {
					let foundItem = items.find((i) => i.sku === reorderItems[j].item.sku);
					if (foundItem) {
						foundItems = foundItems + 1;
					}
				}
			}
			menus[i].foundItems = foundItems;
			menuForReorder.push(menus[i]);
		}
		menuForReorder.sort((a, b) => b.foundItems - a.foundItems);
		if (menuForReorder[0] && menuForReorder[0].foundItems > 0) {
			return filterMenu(menuForReorder[0]);
		} else {
			return false;
		}
	};
	continueOnMenu = async () => {
		const { dispatch, deliveryOption } = this.props;
		const { selectedIkentooMenu, selectedTime } = this.state;
		const isCharterDelivery = deliveryOption ? (deliveryOption.id === 'charter-delivery' ? true : false) : false;
		if (Basket.getRestaurant() && selectedIkentooMenu) {
			const choosenRestaurant = Basket.getRestaurant();
			const businessLocationId = choosenRestaurant.business_location_id;
			if (Basket.collection_time !== 'asap') {
				Basket.setCollectionTime(isCharterDelivery ? this.state.formatted : selectedTime.formattedDT);
			}
			Basket.setMenu(selectedIkentooMenu);
			dispatch(getIkentooMenu(selectedIkentooMenu, businessLocationId, true, 'delivery'));
			dispatch(passedTheOrder(true));
			Basket.setPassedOrder(true);
		} else {
			this.setState({ error: 'Please select location menu' });
		}
	};
	getMenusForDeliverySelectedTime = (menusForLocation = [], selectedTime, json_time_selector = []) => {
		if (isObject(menusForLocation) && !isArray(menusForLocation)) {
			menusForLocation = [menusForLocation];
		}
		let filtered = menusForLocation.filter((menu) => {
			const ikentooMenuId = menu.ikentooMenuId;
			if (!isEmptyObject(selectedTime)) {
				if (selectedTime !== 'asap') {
					const target_menu = selectedTime?.menuIds?.find((i) => i === ikentooMenuId);
					if (target_menu) {
						return true;
					}
				} else {
					return true;
				}
			}
			return false;
		});
		if (json_time_selector.length > 0 && json_time_selector[0].menuId) {
			const now = moment().tz(getConfig().timezone);
			const day = now.day();
			const pickTime = now.format('H:mm');
			filtered = filtered.filter((menu) => {
				const target_menus = json_time_selector.filter((i) => i.menuId.toString() === menu.ikentooMenuId.toString());
				for (let i = 0; i < target_menus.length; i++) {
					const dayAvailability = (target_menus[i].availability || []).filter((a) => a.d === `w${day}`);
					if (dayAvailability.length > 0) {
						return true;
					}
				}
				return false;
			});
		}
		return filtered;
	};

	setTime = (e, deliverytimes, isPicker) => {
		const { deliveryOption } = this.props;
		const charterDelivery = deliveryOption ? (deliveryOption.id === 'charter-delivery' ? true : false) : false;
		const findPickedDT = isPicker ? deliverytimes.find((dt) => e.valueText === dt.text) : e;
		if (charterDelivery) {
			this.setState({ selectedTime: findPickedDT });
		} else {
			let restaurant = Basket.getRestaurant();
			let slots = restaurant?.delivery_times_json?.slots;
			let cutoffTimeRes = cutoffTime(findPickedDT.formattedDT, slots);
			this.setState({ selectedTime: findPickedDT }, async () => {
				if (findPickedDT.menuIds.length > 1) {
					const businessLocationId = restaurant?.business_location_id;
					if (businessLocationId) {
						try {
							let menus = await api.getIkentooMenusForLocation(businessLocationId);
							const time_selector = restaurant?.delivery_times_json || [];
							menus = getMenusForSelectedTime(menus, 'asap', time_selector);
							this.props.dispatch({ type: SET_RESTAURANT_PROP, key: 'ikentooMenusForLocation', value: menus });
						} catch (e) {
							console.error('Error fetching menus for delivery:', e);
						}
					}
					this.props.dispatch(setCommonModal('isChooseMenuModalOpen', true));
				} else if (findPickedDT.menuIds.length === 1) {
					this.setState({ selectedIkentooMenu: findPickedDT.menuIds[0] });
				}
			});
			Basket.setCutoffTime(cutoffTimeRes);
		}
	};

	changeTime = (selectedTime, minDT) => {
		if (selectedTime && minDT) {
			let h = parseInt(selectedTime.split(':')[0]);
			let m = parseInt(selectedTime.split(':')[1]);
			const formattedDT = moment(minDT).hours(h).minutes(m);
			this.setState({ pickTime: selectedTime, selectedTime, formatted: formattedDT }, () => {
				Basket.setOrderType('charter-delivery');
			});
		} else {
			this.setState({ pickTime: null });
		}
	};

	setPickTime = (inst, minDT) => {
		if (inst && inst.getVal()) {
			this.changeTime(inst.getVal(), minDT);
		} else {
			this.setState({ pickTime: null });
		}
	};

	changeTimeOption = (option, timePickerOptions, minDT) => {
		const time = option.value === 1 ? 'asap' : timePickerOptions[0]?.value;
		this.setState({ selectedTimeOption: option, pickTime: time, selectedTime: time });
		this.changeTime(time, minDT);
	};
	checkAvailableSlotsForToday = (restaurant) => {
		let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		let today = days[moment().format('d')];
		const day = {
			Monday: 'w1',
			Tuesday: 'w2',
			Wednesday: 'w3',
			Thursday: 'w4',
			Friday: 'w5',
			Saturday: 'w6',
			Sunday: 'w0',
		};
		let selectedRestaurant = restaurant
		let deliveryTimes = selectedRestaurant.charter_delivery_times_json;
		let flag = false;
		if (!isEmptyObject(deliveryTimes)) {
			for (let i = 0; i < deliveryTimes.length; i++) {
				deliveryTimes[i].availability.forEach((dt) => {
					if (dt.d === day[today] && dt?.active !==false) {
						let addedTime = null;
						addedTime = moment().add(restaurant.charter_delivery_order_slot_lead_time, 'minutes');
						if (addedTime.isBefore(moment(dt.end, 'hh:mm'))) {
							flag = true;
						}
					}
				});
			}
		}

		return flag;
	};
	backHandler = () => {
		if (this.props.location?.state?.skipToDeliveryTime) {
			forwardTo('/delivery')
		} else {
			goBack()
		}
	}
	render() {
		const { __, deliveryOption, isChooseMenuModalOpen, ikentooMenusForLocation } = this.props;
		const deliveryOptionBasket = Basket.getDeliveryOption();
		const { selectedTime, selectedIkentooMenu, pickTime, selectedTimeOption, showOnlyPickUpText } = this.state;
		const restaurant = Basket.getRestaurant();
		const charterDelivery = deliveryOptionBasket ? (deliveryOptionBasket.id === 'charter-delivery' ? true : false) : false;
		const deliveryTimesJson = restaurant ? restaurant.delivery_times_json : null;
		const charterTimesJson = restaurant ? restaurant.charter_delivery_times_json : null;
		const timesJson = deliveryOptionBasket ? (deliveryOptionBasket.id === 'charter-delivery' ? charterTimesJson : deliveryTimesJson) : deliveryTimesJson;
		const hasTimeDelivery = !isEmptyObject(deliveryTimesJson) && !isEmptyObject(deliveryTimesJson.slots);
		const hasTimeCharterDelivery = !isEmptyObject(charterTimesJson);
		const hasTime = hasTimeDelivery ? hasTimeDelivery : hasTimeCharterDelivery;
		const animationMenuClass = isChooseMenuModalOpen ? 'show-up' : '';
		const menus = charterDelivery ? getMenusForSelectedTime(ikentooMenusForLocation, selectedTime, charterTimesJson) : this.getMenusForDeliverySelectedTime(ikentooMenusForLocation, selectedTime, deliveryTimesJson || []);
		const currentDT = moment().tz(getConfig().timezone);
		let minDT = currentDT;
		if (restaurant && isDefined(restaurant.charter_delivery_order_slot_lead_time) && shouldAddPrepTime()) {
			minDT.add(restaurant.charter_delivery_order_slot_lead_time, 'minutes');
		}
		const orderType = deliveryOptionBasket.id;
		let additionalSettings = restaurant && restaurant.additional_delivery_settings ? restaurant.additional_delivery_settings : {};
		additionalSettings = additionalSettings[orderType];
		let restaurantIsClosed = false
		if (additionalSettings && additionalSettings.asap === false && additionalSettings.timePicker === false && !isStoreOpened(restaurant)) {
			restaurantIsClosed = true
		} else {
			restaurantIsClosed = false
		}
		const snoozedTimes = checkSnoozedTimes(restaurant, 'charter-delivery');
		let timePickerOptions = restaurantIsClosed ? [{ text: 'CLOSED', value: null }] : formatDataForTime(restaurant, minDT, restaurant?.id, true, false, snoozedTimes);

		const can_charter_delivery_order = restaurant && isDefined(restaurant.can_charter_delivery_order) ? restaurant.can_charter_delivery_order : false;

		const timeOptions = [
			{ text: 'ASAP', value: 1 },
			{ text: 'Pre-order for later', value: 2 },
		];

		const headerTitle = deliveryOption && (deliveryOption.id === 'delivery' || deliveryOption.id === 'charter-delivery') ? 'Delivery Time' : 'Drop-off Time';
		const hasPickUpText = additionalSettings?.hasPickUpText;
		const pickUpText = additionalSettings?.pickUpText;
		const distance = [...this.props.location?.state?.checkedCodeData || []]?.find(el => el?.restaurant_id == restaurant?.id)?.distance || null
		return (
			<Loading>
				<Layout backHandler={this.backHandler} title={__(headerTitle)} headerWithTitle={true} color="transparent">
					{!this.props.location?.state?.saveOrderData && <>
						<div style={Basket.has_multi_basket ? { visibility: 'hidden' } : {}} className="box-with-shadow absolute-content">
								<Title className="web-only page-title-centered">
									{__(deliveryOption && (deliveryOption.id === 'delivery' || deliveryOption.id === 'charter-delivery') ? __('Delivery Time') : __('Drop-off Time'))}
								</Title>
								{hasTime && !showOnlyPickUpText ? (
									<>
										<StrongText className='page-title-centered'>
											{__(
												deliveryOption && (deliveryOption.id === 'delivery' || deliveryOption.id === 'charter-delivery')
													? __('Select the time for your order to be delivered')
													: __('Select your prefered drop-off time'),
											)}
										</StrongText>
										<Spacer size={2} />
										<IonList lines="full">
											{charterDelivery ? (
												<div className="time-picker-wrapper box-wrapper click-and-collect-timepicker-wrapper">
													<SelectOption
														theme='ios'
														cssClass={isWebConfig() ? 'web' : ''}

														display="inline"
														onSet={(e, inst) => this.setPickTime(inst, minDT)}
														data={timePickerOptions}
														label="Location"
														value={pickTime}
														inputStyle="box"
														placeholder={__('Select Collection Time')}
														setText={__('OK')}
														cancelText={__('Cancel')}
														disabled={this.state.selectedRestaurant === null ? true : false}
														onInit={() => {
															if (timePickerOptions.length > 0) {
																const firstAvailableTime = timePickerOptions.find((i) => i.value !== null && i.disabled !== true);
																if (!pickTime && firstAvailableTime && pickTime !== firstAvailableTime.value) {
																	this.changeTime(firstAvailableTime.value, minDT);
																}
															}
														}}
													/>

												</div>
											) : (
												<IonRadioGroup value={selectedTime} onIonChange={(e) => this.setTime(e.detail.value)}>
													{this.formatTimes(timesJson).list.map((dt, index) => {
														return (
															<IonItem key={'delivery-time-' + index}>
																<div tabIndex="-1"></div>
																<IonRadio color="primary" slot="start" value={dt} />
																<IonLabel >
																	<strong>{dt.text}</strong>
																</IonLabel>
															</IonItem>
														);
													})}
												</IonRadioGroup>
											)}
										</IonList>
									</>
								) : null}
								{!charterDelivery &&
									(this.formatTimes(timesJson).picker.length > 0 ? (
										<IonButton

											className="link"
											color="secondary"
											onClick={() => {
												this.pickerRef.current.instance.show();
											}}
										>
											{__((hasTime ? 'Or choose later' : 'Choose') + ' delivery time')}
										</IonButton>
									) : null)}
								{showOnlyPickUpText ? (
									<></>
								) : charterDelivery ? (
									<div>
										{selectedTimeOption && selectedTimeOption.value === timeOptions[1].value && (
											<SelectOption
												theme='ios'
												cssClass={isWebConfig() ? 'web' : ''}

												display="inline"
												onSet={(e, inst) => this.setPickTime(inst, minDT)}
												data={timePickerOptions}
												label="Location"
												value={pickTime}
												inputStyle="box"
												placeholder={__('Select Collection Time')}
												setText={__('OK')}
												cancelText={__('Cancel')}
												disabled={this.state.selectedRestaurant === null ? true : false}
												onInit={() => {
													if (timePickerOptions.length > 0) {
														const firstAvailableTime = timePickerOptions.find((i) => i.value !== null);
														if (!pickTime && firstAvailableTime && pickTime !== firstAvailableTime.value) {
															this.changeTime(firstAvailableTime.value, minDT);
														}
													}
												}}
											/>
										)}
									</div>
								) : (
									<div style={{ display: 'none' }}>
										<SelectOption
											theme='ios'
											cssClass={isWebConfig() ? 'web' : ''}

											ref={this.pickerRef}
											display="center"
											onSet={(e) => {
												this.setTime(e, this.formatTimes(timesJson).picker, true);
											}}
											data={this.formatTimes(timesJson).picker}
											label="Location"
											inputStyle="box"
											placeholder={__('Select Collection Time')}
											setText={__('OK')}
											cancelText={__('Cancel')}
										/>
									</div>
								)}
								{hasPickUpText && (
									<div>
										<Spacer size={2} />
										<div dangerouslySetInnerHTML={{ __html: pickUpText }} />
									</div>
								)}
								{(!Basket.has_multi_basket && !this.props.location?.state?.collectionTimeRestaurant) &&
									<>
										<Spacer size={5} />
										<div className='box-content delivery-time-selected-restaurant'>
											<div >
												<StrongText className='text-to-update block'>{restaurant?.name}</StrongText>
												{this.props.location?.state?.checkedCodeData?.length > 1 &&
													<EditIcon onClick={() => { this.setState({ selectRestaurantModalOpen: true }) }} className='fill-text' style={{ margin: 0 }} />

												}
											</div>
											<div>
												<PillGroup items={[
													distance
														? `${parseFloat(distance?.toFixed(2)) == 1 ? distance?.toFixed(0) : distance?.toFixed(2)} ${__(getDistanceUnit(parseFloat(distance?.toFixed(2)) == 1))}`
														: null,
													(parseFloat(this.props.location?.state?.checkedCodeData?.find(res => res?.restaurant_id == restaurant?.id)?.delivery_zone?.price ?? 0)) > 0
														? `${Basket.formatPrice(this.props.location?.state?.checkedCodeData?.find(res => res?.restaurant_id == restaurant?.id)?.delivery_zone?.price)} ${__('delivery')}`
														: null,
													(parseFloat(this.props.location?.state?.checkedCodeData?.find(res => res?.restaurant_id == restaurant?.id)?.delivery_zone?.min_order ?? 0)) > 0
														? `${Basket.formatPrice(this.props.location?.state?.checkedCodeData?.find(res => res?.restaurant_id == restaurant?.id)?.delivery_zone?.min_order)} ${__('min order')}`
														: null,
												].filter(Boolean)} />
											</div>
										</div>
									</>
								}
								<Spacer size={5} />
								<div className="flex-min">

									<IonButton
										disabled={restaurantIsClosed || (can_charter_delivery_order ? (charterDelivery ? !pickTime && !selectedTime : !selectedTime) : true)}
										expand="block"
										color="primary"
										className={`button-uppercase ${this.state.continueButtonClicked ? 'unclicked' : ''}`}
										onClick={() => this.confirmTime()}
									>
										{__('Continue')}
									</IonButton>
								</div>

						</div>
						{!this.props.location?.state?.collectionTimeRestaurant &&

							<Modal
								{...(Basket.has_multi_basket ? {} : { onDidDismiss: () => { this.setState({ selectRestaurantModalOpen: false }) } })}
								isOpen={this.state.selectRestaurantModalOpen}

							>
								<StrongText style={{ marginBottom: 'var(--spacer-2)' }} className='modal-title'>{__(Basket.has_multi_basket ? 'Select a menu' : 'Select a location')}</StrongText>
								<IonList className={` ${getConfig().general.tiledRestaurantView ? 'tiled-box-wrapper' : 'box-wrapper'}`}>
									<IonRadioGroup >
										{this.props.location.state.checkedCodeData
											.map((res, i) => {
												const { restaurant_name, restaurant_address, delivery_zone, restaurant_id } = res;
												const price = res.delivery_zone.price;
												let selectedRestaurant = this.props.restaurants.find(el => el.id == restaurant_id)
												const image = selectedRestaurant?.image || ''
												const availableSlosts = this.checkAvailableSlotsForToday(selectedRestaurant);
												const minOrder = res?.delivery_zone?.min_order || 0
												const deliveryPrice = res?.delivery_zone?.price || 0
												return (
													<React.Fragment key={`res_${i}`}>
														{getConfig().general.tiledRestaurantView ? <IonItem
															className="pointer box-wrapper"
															disabled={!availableSlosts}
															lines="none"
															key={i}
															onClick={() => {
																this.setState({
																	selectRestaurantModalOpen: false
																}, () => {
																	Basket.setRestaurant(selectedRestaurant)
																	Basket.setDeliveryMinOrder(minOrder)
																	Basket.setDeliveryPrice(deliveryPrice)
																	if (Basket.has_multi_basket) {
																		this.confirmTime()

																	}
																})
															}}
														>
															<div style={{ width: '100%' }}>
																<img src={image} />
																<div>
																	<StrongText className='block text-to-update'>{__(restaurant_name)}</StrongText>
																	<div className="restaurant-data" >
																		{!getConfig().flags.removeDeliveryRestaurantAdditionalInformation && (
																			<>
																				<SmallText className='block'>

																					{price > 0
																						? selectedRestaurant?.delivery_charge_in_percent
																							? `${__('Delivery price')} -  ${price}%`
																							: `${__('Delivery price')} - ${Basket.formatPrice(price)}`
																						: `${__('Free Delivery')}`}
																				</SmallText>
																				{minOrder > 0 &&
																					<SmallText className="block">
																						{__('Minimun Order')} - {Basket.formatPrice(minOrder)}
																					</SmallText>
																				}
																			</>
																		)}
																	</div>
																</div>
																<SmallText className="restaurant-status" >{!availableSlosts ? __('Service Unavailable') : ` ${__('OPEN')}`}</SmallText>
															</div>
														</IonItem> :
															<IonItem onClick={() => {
																Basket.setRestaurant(selectedRestaurant);
																Basket.setDeliveryMinOrder(minOrder)
																Basket.setDeliveryPrice(deliveryPrice)
															}} key={i} lines="none" className='restaurant-wrapper' disabled={!availableSlosts}>
																<div tabIndex="-1"></div>

																<div className='round-radio-wrapper'>
																	<IonRadio slot="start" disabled={!availableSlosts} />
																	<IonCheckbox className='round-checkbox' checked />
																</div>
																<IonLabel className="ion-text-wrap" color="dark">
																	<StrongText className='block text-to-update'>{restaurant_name}</StrongText>
																	<Spacer size={0} />
																	<SmallText className="block">{restaurant_address}</SmallText>
																	<div className="delivery-additional-restaurant-information">
																		{!getConfig().flags.removeDeliveryRestaurantAdditionalInformation && (
																			<div>
																				<SmallText className="block">
																					{price > 0
																						? selectedRestaurant?.delivery_charge_in_percent
																							? `${__('Delivery price')} -  ${price}%`
																							: `${__('Delivery price')} - ${Basket.formatPrice(price)}`
																						: `${__('Free Delivery')}`}
																				</SmallText>
																				{minOrder > 0 &&
																					<SmallText className="block">
																						{__('Minimun Order')} - {Basket.formatPrice(minOrder)}
																					</SmallText>
																				}
																			</div>
																		)}
																		<SmallText className="restaurant-opening-time"> {!availableSlosts ? __('Service Unavailable') : ` ${__('OPEN')}`}</SmallText>
																	</div>
																</IonLabel>
															</IonItem>
														}</React.Fragment>
												);
											})}
									</IonRadioGroup>
								</IonList>
								<Spacer size={5} />
								{!getConfig().general.tiledRestaurantView &&
									<IonButton className='button-uppercase' expand='block' onClick={() => this.setState({ selectRestaurantModalOpen: false }, () => {
										if (Basket.has_multi_basket) {
											this.confirmTime()
										}
									})}>{__('Continue')}</IonButton>

								}
							</Modal>
						}

						{!menus.length ? null : (
							<>
								<Modal
									isOpen={isChooseMenuModalOpen}
									onDidDismiss={() => {
										if (additionalSettings && additionalSettings.asap === false && additionalSettings.timePicker === false) {
											goBack();
										}
										this.props.dispatch(setCommonModal('isChooseMenuModalOpen', false));
									}}
								>
									<Title className='modal-title'>{__('Choose menu')}</Title>
									<Spacer size={5} />
									<IonList lines="none" className="box-wrapper menus-wrapper">
										<IonRadioGroup onIonChange={this.changeIkentooMenus} value={selectedIkentooMenu}>
											{menus.length === 0 ? (
												<NoData />
											) : (
												menus.map((menu) => {
													const { ikentooMenuId, menuName } = menu;
													return (
														<IonItem key={ikentooMenuId} lines="none">
															<div tabIndex="-1"></div>
															<IonRadio color='primary' slot="start" value={ikentooMenuId} />
															<StrongText className="ion-text-wrap" >
																{menuName}
															</StrongText>
														</IonItem>
													);
												})
											)}
										</IonRadioGroup>
									</IonList>
									<Spacer size={5} />
									<IonButton className='button-uppercase' disabled={menus.length > 0 ? false : true} expand="block" color="primary" onClick={() => this.continueOnMenu()}>
										{__('Continue')}
									</IonButton>
								</Modal>

							</>
						)}
					</>}
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { deliveryOption, deliveryAddress, pickUpPoint } = state.orders;
	const { isChooseMenuModalOpen } = state.common;
	const { ikentooMenusForLocation, restaurants } = state.restaurants;
	return {
		deliveryOption,
		deliveryAddress,
		pickUpPoint,
		isChooseMenuModalOpen,
		ikentooMenusForLocation,
		restaurants,
	};
};

export default connect(stateToProps)(withTranslation(DeliveryTime));
